import { z } from "zod";

export const securityTotalsSchema = z.object({
  blockedActive: z.number(),

  community: z.number(),

  local: z.number(),
});

export const securityLiveSchema = z.object({
  alertsLast10m: z.number(),

  alertsLastHour: z.number(),

  underAttack: z.boolean(),

  // Nunca se renderizan: con default no pueden tirar el parse de toda la tab.

  parsed: z.number().default(0),

  unparsed: z.number().default(0),
});

// Valores null = bucket sin datos (hueco honesto en el chart: colector caído

// o backend redeployado en medio de la ventana de 24h).

export const securitySeriesPointSchema = z.object({
  t: z.string(),

  blockedActive: z.number().nullable(),

  alertsLast10m: z.number().nullable(),

  local: z.number().nullable(),
});

export const securityRecentAlertSchema = z.object({
  ip: z.string(),

  scenario: z.string(),

  country: z.string().nullable(),

  as: z.string().nullable(),

  events: z.number(),

  createdAt: z.string(),
});

export const securityRecentDecisionSchema = z.object({
  ip: z.string(),

  scenario: z.string(),

  duration: z.string(),

  origin: z.string(),

  country: z.string().nullable(),

  firstSeenAt: z.string().optional(),

  lastSeenAt: z.string().optional(),
});

export const securityTopScenarioSchema = z.object({
  scenario: z.string(),

  count: z.number(),
});

export const zapRiskSchema = z.enum(["high", "medium", "low", "info"]);

export const zapCountsSchema = z.object({
  high: z.number(),

  medium: z.number(),

  low: z.number(),

  info: z.number(),
});

export const zapAlertSchema = z.object({
  name: z.string(),

  risk: zapRiskSchema,

  instances: z.number(),
});

export const zapTargetSchema = z.object({
  target: z.string(),

  slug: z.string(),

  scannedAt: z.string(),

  reportUrl: z.string(),

  counts: zapCountsSchema,

  alerts: z.array(zapAlertSchema),
});

export const zapOverviewSchema = z.object({
  updatedAt: z.string().nullable().default(null),

  stale: z.boolean().default(true),

  scanKind: z.enum(["baseline", "full"]).nullable().default(null),

  totals: zapCountsSchema.default({ high: 0, medium: 0, low: 0, info: 0 }),

  targets: z.array(zapTargetSchema).default([]),
});

export const securityOverviewSchema = z.object({
  updatedAt: z.string().nullable(),

  stale: z.boolean(),

  // El colector reportó con fuentes caídas (cscli/LAPI/ipset).

  degraded: z.boolean().default(false),

  totals: securityTotalsSchema,

  live: securityLiveSchema,

  // Defaults en las listas: un backend viejo/parcial no tira toda la tab.

  series: z.array(securitySeriesPointSchema).default([]),

  recentAlerts: z.array(securityRecentAlertSchema).default([]),

  recentDecisions: z.array(securityRecentDecisionSchema).default([]),

  topScenarios: z.array(securityTopScenarioSchema).default([]),

  zap: zapOverviewSchema.default({
    updatedAt: null,

    stale: true,

    scanKind: null,

    totals: { high: 0, medium: 0, low: 0, info: 0 },

    targets: [],
  }),
});

export type SecurityTotals = z.infer<typeof securityTotalsSchema>;

export type SecurityLive = z.infer<typeof securityLiveSchema>;

export type SecuritySeriesPoint = z.infer<typeof securitySeriesPointSchema>;

export type SecurityRecentAlert = z.infer<typeof securityRecentAlertSchema>;

export type SecurityRecentDecision = z.infer<
  typeof securityRecentDecisionSchema
>;

export type SecurityTopScenario = z.infer<typeof securityTopScenarioSchema>;

export type ZapRisk = z.infer<typeof zapRiskSchema>;

export type ZapCounts = z.infer<typeof zapCountsSchema>;

export type ZapAlert = z.infer<typeof zapAlertSchema>;

export type ZapTarget = z.infer<typeof zapTargetSchema>;

export type ZapOverview = z.infer<typeof zapOverviewSchema>;

export type SecurityOverview = z.infer<typeof securityOverviewSchema>;

/** Rango de tiempo de la serie temporal (selector del backoffice). */

export type SecurityRange = "day" | "week" | "month";
